module.exports = __webpack_public_path__ + "img/icon-line.4b0c7853.svg";